import { render, staticRenderFns } from "./vias.vue?vue&type=template&id=517b2fe6&scoped=true"
import script from "./vias.vue?vue&type=script&lang=js"
export * from "./vias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517b2fe6",
  null
  
)

export default component.exports